import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryCounts_ds_get_inventory_count_discrepancies_singleService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { inventoryCountIds?: number }): 
  Promise<{ result: { Id?: number, ActualAmount?: number, CreatedSysDateTime?: string, InventoryCountId?: number, ResolvedDatetime?: string, TaskId?: number, Status?: { Id?: number, Name?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/InventoryCounts/datasources/ds_get_inventory_count_discrepancies_single/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { inventoryCountIds?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualAmount?: number, CreatedSysDateTime?: string, InventoryCountId?: number, ResolvedDatetime?: string, TaskId?: number, Status?: { Id?: number, Name?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/InventoryCounts/datasources/ds_get_inventory_count_discrepancies_single/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { inventoryCountIds?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualAmount?: number, CreatedSysDateTime?: string, InventoryCountId?: number, ResolvedDatetime?: string, TaskId?: number, Status?: { Id?: number, Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryCounts/datasources/ds_get_inventory_count_discrepancies_single/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      inventoryCountIds?: number    }) {
      return false;
    }
}
